// extracted by mini-css-extract-plugin
module.exports = {"PowerUpsList":"PowerUpsList_PowerUpsList__2PymL","List":"PowerUpsList_List__Dth3B"};